import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Login } from '@/features/User/Pages/Login';
import { Register } from '@/features/User/Pages/Register';
import { ResetPassword } from '@/features/User/Pages/ResetPassword';
import ResetPasswordConfirm from '@/features/User/Pages/ResetPasswordConfirm';
import Validate from '@/features/User/Pages/Validate';
import Validated from '@/features/User/Pages/Validated';
import Home from '@/features/Home/Home';
import Authguard from './react-router-dom/Authguard';
import UserComplete from '@/features/User/Pages/UserComplete';
import List from '@/features/List/Pages/List';
import WishForm from '@/features/Wish/Pages/WishForm';
import ListShared from '@/features/List/Pages/ListShared';
import ListsShared from '@/features/List/Pages/ListsShared';
import Profile from '@/features/User/Pages/Profile';
import UserContact from '@/features/User/Pages/UserContact';

export const router = createBrowserRouter([
	{
		path: '/contactme',
		element: <UserContact />,
	},
	{
		path: '/register',
		element: <Register />,
	},
	{
		path: '/reset-password',
		element: <ResetPassword />,
	},
	{
		path: '/reset-password/confirm',
		element: <ResetPasswordConfirm />,
	},
	{
		path: '/validate',
		element: <Validate />,
	},
	{
		path: '/validated',
		element: <Validated />,
	},
	{
		path: '/shared/:public_uid',
		element: <ListShared />,
		children: [
			{
				path: ':id_wish',
				element: <ListShared />,
			},
		],
	},
	{
		path: '/*',
		element: <Authguard />,
		children: [
			{
				path: 'home',
				element: <Home />,
			},
			{
				path: 'list/:id_list/*',
				children: [
					{
						path: 'add',
						element: <WishForm />,
					},
					{
						path: 'edit/:id_wish',
						element: <WishForm />,
					},
					{
						path: '',
						element: <List />,
						children: [
							{
								path: ':id_wish',
								element: <List />,
							},
						],
					},
				],
			},
			{
				path: 'lists',
				element: <ListsShared />,
			},
			{
				path: 'profile/*',
				children: [
					{
						path: 'form',
						element: <UserComplete />,
					},
					{
						path: '',
						element: <Profile />,
					},
				],
			},
			{
				path: '/*',
				element: <Login />,
			},
		],
	},
	{
		path: '*',
		element: <Navigate to="/home" replace />,
	},
]);
